import { useAuth0 } from "@auth0/auth0-react";

import { cleanup } from "./authService";

const LogoutButton = () => {
  const { logout } = useAuth0();

  const handleLogout = () => {
    // Remove the Auth0 token from localStorage
    localStorage.removeItem('auth0Token');
    
    // Clean up any refresh intervals
    cleanup();
    
    // Call Auth0 logout
    logout({ 
      logoutParams: { 
        returnTo: import.meta.env.VITE_AUTH0_LOGOUT_URL 
      }
    });
  };

  return (
    <button 
      className="bg-slate-600 hover:bg-slate-500 active:bg-slate-600 w-full rounded-md px-3 py-2 text-sm font-medium text-white transition-all focus:outline-none focus-visible:ring-2 focus-visible:ring-slate-500 focus-visible:ring-offset-2" 
      onClick={handleLogout}
    >
      Log Out
    </button>
  );
};

export default LogoutButton;
